import { render } from "./rightNumberLeftImageSection.vue?vue&type=template&id=652ac892&scoped=true"
import script from "./rightNumberLeftImageSection.vue?vue&type=script&lang=js"
export * from "./rightNumberLeftImageSection.vue?vue&type=script&lang=js"

import "./rightNumberLeftImageSection.vue?vue&type=style&index=0&id=652ac892&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652ac892"]])

export default __exports__